import { createFileRoute } from '@tanstack/react-router';
import { BrandMark } from '../../components/layout/BrandMark';
import { Button } from '../../components/ui/button';
import { Skeleton } from '../../components/ui/skeleton';
import { trpc } from '../../lib/trpc';

/**
 * Public page reached from a shared connect link. Lets a household member
 * (re)connect their bank with BankID without logging in to Budgie.
 */
export const Route = createFileRoute('/connect/$token')({
  component: ConnectLinkPage,
});

function ConnectLinkPage() {
  const { token } = Route.useParams();
  const info = trpc.enableBanking.connectLinkInfo.useQuery({ token }, { retry: false });
  const start = trpc.enableBanking.startLinkAuth.useMutation({
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex justify-center">
          <BrandMark />
        </div>
        <div className="rounded-2xl border border-border bg-card p-6 text-center sm:p-7">
          <span
            aria-hidden
            className="mx-auto flex size-12 items-center justify-center rounded-full bg-muted text-2xl"
          >
            🏦
          </span>
          <h1 className="mt-4 text-xl font-semibold tracking-tight">Förnya bankkoppling</h1>

          {info.isLoading && (
            <div className="mt-4 space-y-2">
              <Skeleton className="mx-auto h-4 w-56" />
              <Skeleton className="mx-auto h-4 w-40" />
              <Skeleton className="mt-4 h-10 w-full" />
            </div>
          )}

          {info.isError && (
            <p className="mt-3 rounded-lg bg-negative-soft px-3 py-2 text-sm text-negative">
              Länken är ogiltig eller har återkallats.
            </p>
          )}

          {info.data && (
            <>
              <p className="mt-2 text-sm text-muted-foreground">
                Hej {info.data.label}! Godkänn med BankID så hämtar Budgie dina transaktioner från{' '}
                {info.data.aspspName} igen.
              </p>
              <Button
                className="mt-6 w-full"
                size="lg"
                disabled={start.isPending}
                onClick={() => start.mutate({ token })}
              >
                {start.isPending ? 'Ansluter…' : `Anslut ${info.data.aspspName} via BankID`}
              </Button>
              {start.error && <p className="mt-3 text-sm text-negative">{start.error.message}</p>}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
